import { alpha, useTheme } from '@mui/material';
const useSImageStyles = () => {
    const theme = useTheme();
    return {
        MediaContainer: {
            width: '100%',
            borderRadius: 1,
            overflow: 'hidden',
            position: 'relative'
        },
        Image: {
            width: '100%',
            height: '100%',
            objectFit: 'cover'
        },
        FullScreenIcon: {
            position: 'absolute',
            bottom: 7,
            right: 7,
        },
        Chip: {
            display: 'inline-flex',
            flexShrink: 0,
            background: alpha(theme.palette.common.black, 0.32),
            position: 'absolute',
            top: 8,
            left: 8,
            color: theme.palette.common.white
        }
    };
};
export default useSImageStyles;
